import { styled } from '@mui/material/styles';

/** This exists to create the space required by NavbarTop, which changes with the viewport. */
export const NavbarTopSpacer = styled('div')(({ theme }) => ({
  ...theme.mixins.toolbar,
  backgroundColor: theme.palette.midnight.main,
}));
